import React from "react";
import Intro from "./components/Intro";
import Services from "./components/Services";
import About from "./components/About";
import Credits from "./components/Credits";
import NavBar from "./components/NavBar";
import SideNavBar from "./components/SideNavBar";
import Projects from "./components/Projects";
import Pricing from "./components/Pricing";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import MailDashboard from "./components/MailDashboard";
import StarBackground from "./components/StarBackground";
import "./App.css";
import "./styles/Global.css";

function App() {
  return (
    <div className="App">
      <StarBackground />
      <NavBar />
      <SideNavBar />
      <main id="content">
        <Intro />
        <Services />
        <Projects />
        <MailDashboard />
        <About />
        <Pricing />
        <FAQ />
        <Contact />
        <Credits />
      </main>
    </div>
  );
}

export default App;
